import { SupplementGroupState } from 'types';
import AppConstants from 'constants/AppConstants';

export function setSupplementGroupStates(
  supplementGroupStates: SupplementGroupState[]
): BaseTockAction {
  return {
    type: AppConstants.SUPPLEMENT_GROUPS_SET_STATES,
    payload: supplementGroupStates,
  };
}

export function setSupplementGroupPackageStates(
  supplementGroupStates: SupplementGroupState[],
  ticketTypeId: number
): BaseTockAction {
  const PackageStateObject = {
    supplementGroupStates,
    ticketTypeId,
  };
  return {
    type: AppConstants.SUPPLEMENT_GROUPS_PACKAGE_SET_STATES,
    payload: PackageStateObject,
  };
}
